module.exports = __webpack_public_path__ + "0059f92a23530a8ef5e94a65a4d4b5f4.jpg";